import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import styled from "styled-components";
import iconHelp from "../../../../../images/icon-help.svg";
import HeaderButton from "../buttons/HeaderButton";
import {logAction} from "../../../../logging/logEvent";

const Icon = styled.img`
    width: 9px;
    height: 18.12px;
`;

const HelpButton = () => {
    const openUpHelp = () => {
        window.open("https://ideasequities.timgroup.com/TradeIdeasMonitor/openpopup.htm?page=com.youdevise.ids.controller.AboutController", "TIM Help",
          'height=' + 525 + ','
          + 'width=' + 450 + ','
          + 'toolbar=no,'
          + 'directories=no,'
          + 'status=no,'
          + 'menubar=no,'
          + 'scrollbars=no,'
          + 'resizable=no,'
          + 'modal=yes');

        logAction({ type: "SHOW_HELP" });
    };

    const onClick = () => {
        openUpHelp();
    };
    return <HeaderButton onClick={onClick} className="t-help-button">
        <Icon src={iconHelp}/>
    </HeaderButton>
};

export default HelpButton;
